module.exports = __webpack_public_path__ + "img/Profile.5c9c1feb.jpg";